// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timing-text{font-size:9pt;width:26px;height:20px;line-height:20px;text-align:right}\n", ""]);
